var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"alert-message form-alert",attrs:{"fade":"","show":_vm.countdown,"dismissible":_vm.dismissable,"variant":_vm.variant},on:{"dismiss-count-down":_vm.countdownChanged,"dismissed":_vm.onDismiss}},[_c('template',{slot:"dismiss"},[_vm._v("Hide")]),_c('p',{class:[
      'form-alert__text',
      {
        'form-alert__text--fn': _vm.click
      }
    ],on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }